//备注通用组件所需方法
import $http from '@/resource';
import utils from '@/utils';

const $api = {};
///TODO 补全载体的url
/**
 * 项目备注左侧搜索项
 *
 * @param {string} id 项目|载体id
 * @param {string} type 类型 item-项目，carrier-载体
 *
 * @date 2018-10-22 11:00:214
 *
 * @returns {Promise<any>}
 */
$api.getEditFormOptions = (id,type)=>{
    const promise = new Promise(function(resolve){
        if(!type||!id){
            return resolve({});
        }
        let url = "";
        if(type === "item"){
            //项目
            url = `item/${id}/note-options`;
        }else{
            //载体
            url = `carrier/${id}/note-options`;
        }

        $http.get(url).then(function (response) {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 获取备注区at列表备选项数据
 *
 * @param {string} id 项目|载体 id
 * @param {string} type 类型 item-项目 carrier-载体
 *
 * @date 2018-10-22 20:38:21
 *
 * @returns {Promise<any>}
 */
$api.getAtContactList = (id,type)=>{

    const promise = new Promise(function(resolve){
        if(!type||!id){
            return resolve([]);
        }
        let url = "";
        if(type === "item"){
            //项目
            url = `item/${id}/note-candidates`;
        }else{
            //载体
            url = `carrier/${id}/note-candidates`;
        }

        $http.get(url).then(function (response) {
            resolve(response);
        });
    });
    return promise;
};
/**
 * 获取备注列表
 *
 * @param {string} id 项目|载体 id
 * @param {string} type 类型 item-项目 carrier-载体
 *
 * @date 2018-10-24 19:37:524
 *
 * @returns {Promise<any>}
 */
$api.getRemarkListData = (id,type)=>{
    const promise = new Promise(function(resolve) {
        if (!type || !id) {
            return resolve([]);
        }
        let url = "";
        if(type === "item"){
            //项目
            url = `item/${id}/could-list`;
        }else{
            //载体
            url = `carrier/${id}/cloud-list`;
        }

        $http.get(url).then(function (response) {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 修改备注置顶状态
 *
 * @param {string} id 项目|载体 id
 * @param {string} type 类型 item-项目，carrier-载体
 * @param {object} param {id:string备注id,isTop:string1-置顶2-取消置顶}
 *
 * @date 2018-10-24 19:40:33
 *
 * @returns {Promise<any>}
 */
$api.changeRemarkIsTop = (id,type,param)=>{
    const promise = new Promise(function(resolve) {
        if (!type || !id || !param) {
            return resolve([]);
        }
        let url = "";
        if(type === "item"){
            //项目
            url = `item/${id}/could-top`;
        }else{
            //载体
            url = `carrier/${id}/cloud-top`;
        }

        let data = {
            "istop"     : param.isTop,
            "cloudId"   : param.id
        };
        $http.put(url,data).then(function (response) {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 删除一条备注
 *
 * @param {string} id 项目|载体id
 * @param {string} type 类型 item-项目,carrier-载体
 * @param {string} cloudId 待删除的备注id
 *
 * @date 2018-10-26 09:05:59
 *
 * @returns {Promise<any>}
 */
$api.deleteRemarkById = (id,type,cloudId) => {
    const promise = new Promise(function(resolve) {
        if(!id || !type || !cloudId){
            return resolve([]);
        }
        let url = "";
        if(type === "item"){
            //项目
            url = `item/${id}/could`
        }else{
            //载体
            url = `carrier/${id}/cloud`;
        }
        url += `?cloudId=${cloudId}`;
        $http.delete(url).then(function (response) {
            resolve(response);
        });

    });
    return promise;
};

/**
 * 新增一条备注
 *
 * @param {object} param 待新增的备注内容
 *
 * @date 2018-10-26 09:06:51
 *
 * @returns {Promise<any>}
 */
$api.addNewRemark = (param={}) => {
    const promise = new Promise(function(resolve) {
        if (!param) {
            return resolve([]);
        }

        let url = "";
        if(param.type === "1"){
            //项目
            url = `item/${param.itemId}/could`;
        }else{
            //载体
            url = `carrier/${param.itemId}/cloud`;
        }
        $http.post(url,param).then(function (response) {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 编辑一条备注
 *
 * @param {string} id 项目|载体id
 * @param {string} type 类型item-项目，carrier-载体
 * @param {object} param {cloudId:string备注id,cloud:string} 待编辑的内容
 *
 * @date 2018-10-26 15:19:14
 *
 * @returns {Promise<any>}
 */
$api.editRemark = (id,type,param={}) => {
    const promise = new Promise(function(resolve) {
        if (!param || !id || !type) {
            return resolve([]);
        }
        let url = "";
        if(type === "item"){
            //项目
            url = `item/${id}/could`;
        }else{
            //载体
            url = `carrier/${id}/cloud`;
        }
        $http.put(url,param).then(function (response) {
            resolve(response);
        });
    });
    return promise;
};

/**
 *回复一条备注
 *
 * @param {string} id 项目|载体 id
 * @param {string} type 类型 item-项目，carrier-载体
 * @param {object} param 待提交的内容
 *
 * @date 2018-10-29 19:07:49
 *
 * @returns {Promise<any>}
 */
$api.replyRemark = (id,type,param={}) => {
    const promise = new Promise(function(resolve) {
        if (!param || !id || !type) {
            return resolve([]);
        }
        let url = "";
        if(type === "item"){
            //项目
            url = `item/${id}/could-reply`;
        }else{
            //载体
            url = `carrier/${id}/cloud-reply`;
        }
        $http.post(url,param).then(function (response) {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 修改常用联系人
 * @param {array} uids 常用联系人uid数组
 */
$api.editAlwaysContactUsers = (uids=[]) => {
    const url = `contact-users`;
    const promise = new Promise(resolve => {
        $http.put(url, {uids: uids}).then(response => {
            resolve(response);
        });
    });
    return promise;
};

export default $api;



// WEBPACK FOOTER //
// ./src/service/item/remark.js